import React, { useEffect } from 'react';
import { withLastLocation } from 'react-router-last-location';
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { useParams, useHistory } from 'react-router-dom';
import { getAllJobs } from '../../Actions/FeaturedActions';

import './JobPage.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import { getJob } from '../../Helpers/featured_heplers';
import { isAdminControlMode } from '../../Helpers/ui_helpers';
import { Loader } from '../../Components';
import JobApplicationModal from '../../Components/Landing/Jobs/JobApplicationModal';
import ScrollToTop from '../../Components/General/ScrollToTop';
import { copyToClipboard } from '../../Helpers/helpers';

const JobPage = props => {
  const { ui, featured, getAllJobs } = props;
  const { Job_id } = useParams();
  const history = useHistory();
  const inAdminControlMode = isAdminControlMode(ui);

  const jobs = featured?.jobs || [];
  const jobsAreLoading = !jobs?.length;
  const job = getJob(jobs, Job_id);
  const jobDoesNotExist = !job;
  const { title, summary, qualifications, responsibilities } = job || {};

  const [showApplicationModal, setShowApplicationModal] = React.useState(false);
  const openJobApplicationModal = () => setShowApplicationModal(true);
  const closeJobApplicationModal = () => setShowApplicationModal(false);

  useEffect(() => {
    if (jobs.length) return;
    getAllJobs();
  }, [jobs]);

  const cameFromCareers = props.lastLocation?.pathname?.includes('/careers');
  const headBack = () => (cameFromCareers ? history.goBack() : history.push('/careers'));
  const copyEmailAddress = () => copyToClipboard('careers@shopmy.us', true, 'Email copied to clipboard');

  if (jobsAreLoading) return <Loader />;
  else if (jobDoesNotExist) {
    return (
      <div className='job-page-outer'>
        <div className='job-page-inner'>
          <div className='job-page-section'>
            <div className='back-button' onClick={headBack}>
              <FontAwesomeIcon icon={faArrowLeft} />
              Back to careers
            </div>
          </div>

          <div className='job-page-section'>
            <h1 className='job-title'>Looks like this job isn't available anymore</h1>
            <p>
              Not to worry! We're always looking for new talent. Please check out our other open positions on our <a href='/careers'>careers</a> page
              or drop us a line, we'd love to hear from you!
            </p>
          </div>

          <div className='job-page-section'>
            <button className='contact-us-button' onClick={copyEmailAddress}>
              Contact Us
            </button>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className='job-page-outer'>
        <MetaTags>
          <title>ShopMy Careers | {title}</title>
          <meta property='og:title' content={`ShopMy Careers | ${title}`} />
          <meta property='description' content={summary} />
          <meta property='og:description' content={summary} />
          <meta property='og:image' content='https://static.shopmy.us/uploads/02635319-00bb-4c99-ab98-42a7d4c10a66shopmy_sign.jpg' />
        </MetaTags>
        <ScrollToTop />
        <div className='job-page-inner'>
          {showApplicationModal && <JobApplicationModal job={job} ui={ui} close={closeJobApplicationModal} />}
          <div className='job-page-section'>
            <div className='back-button' onClick={headBack}>
              <FontAwesomeIcon icon={faArrowLeft} />
              Back to careers
            </div>
          </div>

          <div className='job-page-section'>
            <h1 className='job-title'>{title}</h1>
            <h2 className='job-summary'>{summary}</h2>
          </div>

          <div className='job-page-section'>
            <div className='responsibilities-and-qualifications-container'>
              <div className='responsibilities'>
                <div className='column-header'>Responsibilities</div>
                <ul className='column-body'>
                  {responsibilities?.length ? (
                    (responsibilities || '').split('\n\n').map(responsibility => (
                      <li className='responsibility' key={`${title}-responsibility-${responsibility}`}>
                        {responsibility}
                      </li>
                    ))
                  ) : (
                    <li className='responsibility' key={`${title}-responsibility-${responsibilities}`}>
                      No responsibilities listed
                    </li>
                  )}
                </ul>
              </div>
              <div className='qualifications'>
                <div className='column-header'>Qualifications</div>
                <ul className='column-body'>
                  {qualifications?.length ? (
                    (qualifications || '').split('\n\n').map(qualification => (
                      <li className='qualification' key={`${title}-qualification-${qualification}`}>
                        {qualification}
                      </li>
                    ))
                  ) : (
                    <li className='qualification' key={`${title}-qualification-${qualifications}`}>
                      No qualifications listed
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>

          <div className='job-page-section'>
            <button className='application-button' onClick={openJobApplicationModal}>
              {inAdminControlMode ? 'Update Position' : 'Apply Now'}
            </button>
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = state => {
  const { ui, featured } = state;
  return { ui, featured };
};

JobPage.propTypes = {
  ui: PropTypes.object.isRequired
};

export default connect(mapStateToProps, {
  getAllJobs
})(withLastLocation(JobPage));
